<template>
  <div>
    <app-history v-if="editable" @clicked="$emit('click', null)" title=" ثبت سابقه جدید" />

    <v-card class="form" v-for="(item, rowKey) in history.data" :key="rowKey">
      <v-row>
        <v-col
          v-for="(column, columnKey) in history.columns"
          :key="columnKey"
          cols="12"
          sm="12"
          md="6"
          xl="4"
          class="d-flex"
        >
          <v-col class="d-flex" cols="6">
            <b>{{ column.Title }}</b>
          </v-col>

          <template v-if="column.Type == 'file'">
            <v-col cols="6">
              <div v-for="file in item[column.Name]" :key="file.attID">
                <span style="direction: ltr; float: right">
                  {{ file.attName }}</span
                >

                <a
                  class="innerLink resume"
                  @click="
                    callDownload(file.attID, file.attName, file.hashToken)
                  "
                  >دانلود</a
                >
              </div>
            </v-col>
          </template>
          <template v-else>
            <v-col class="d-flex" cols="6">
              <span v-html="getValue(item, column)"></span>
            </v-col>
          </template>
        </v-col>
      </v-row>
      <v-row class="ltr" v-if="item.adminConfirm == 0 && editable">
        <v-btn
          color="red white--text"
          class="register resume"
          @click="$emit('removeRecord', item.Fserial)"
          rounded
        >
          حذف
        </v-btn>
        <v-btn
          color="blue white--text"
          class="register resume"
          rounded
          @click="$emit('click', rowKey)"
        >
          ویرایش
        </v-btn>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import HistoryButton from "@/components/HistoryButton";
import { downloadAttach } from "@/api/resume";
import { saveByteArray } from "@/utils/constants";
export default {
  components: {
    appHistory: HistoryButton,
  },
  methods: {
    getValue(item, column) {
      if (this.history.keys[column.Name] != undefined) {
        const currentKey = this.history.keys[column.Name];
        const currentValue = item[column.Name];

        var selectedValue = Object.keys(currentKey).filter(
          (single) => currentKey[single].SelectId == currentValue
        );

        if (selectedValue.length) {
          return currentKey[selectedValue[0]].Value;
        }
        return "";
      } else if (column.Type == "bool") {
        return item[column.Name] ? "دارد" : "ندارد";
      } else if (column.Name === "adminConfirmStatus") {
        var description = item["adminDescription"]
          ? "، " + item["adminDescription"]
          : "";
        return item[column.Name] + description;
      }
      return item[column.Name];
    },
    callDownload(index, fileName, hashToken) {
      this.$store.commit("SET_PROGRESS_SHOW", true);
      downloadAttach(index, hashToken)
        .then((response) => {
          const data = response.data;
          this.$store.commit("SET_PROGRESS_SHOW", false);
          if (data.Success) {
            saveByteArray(data.Array, fileName);
          } else {
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
  },
  props: ["history", "category", "editable"],
};
</script>
<style>
a.resume {
  margin-right: 10px;
  text-decoration: none;
}
.register.resume {
  max-width: 30% !important;
}
</style>
